import { okhttp } from '../../../httpsnippet-lite/targets/java/okhttp/client.js';
import { convertWithHttpSnippetLite } from '../../../utils/convertWithHttpSnippetLite.js';
/**
 * java/okhttp
 */
export const javaOkhttp = {
    target: 'java',
    client: 'okhttp',
    title: 'OkHttp',
    generate(request) {
        // TODO: Write an own converter
        return convertWithHttpSnippetLite(okhttp, request);
    },
};
